import { FC, useContext } from "react";
import { useAtomValue } from "jotai";

import UndoRedoButtons from "@src/features/builders/shared/undoRedo/UndoRedoButtons";
import {
  BuilderActionContext,
  redoAvailableCountAtom,
  undoAvailableCountAtom,
} from "@src/features/libraryItem/contexts/BuilderActionContext";

export {
  BuilderBottomToolbar,
  BuilderBottomToolbarSeparator,
} from "./BuilderBottomToolbarShell";

export const BuilderBottomToolbarUndoRedo: FC = () => {
  const builderActionContext = useContext(BuilderActionContext);
  const undoAvailableCount = useAtomValue(undoAvailableCountAtom);
  const redoAvailableCount = useAtomValue(redoAvailableCountAtom);
  return (
    <UndoRedoButtons
      undo={() => builderActionContext?.undoAction()}
      redo={() => builderActionContext?.redoAction()}
      undoCount={undoAvailableCount}
      redoCount={redoAvailableCount}
    />
  );
};
